import React from 'react'
import { EmptySpaceWrapper } from './EmptySpace.styles'

interface EmptySpaceProps {
  /**
   * Text to display in the EmptySpace component
   */
  text?: string
  /**
   * Custom text color (not required)
   */
  textColor?: string
  children?: React.ReactNode
}

const EmptySpace: React.FC<EmptySpaceProps> = ({
  text,
  textColor,
  children
}) => {
  return (
    <EmptySpaceWrapper textColor={textColor}>
      {text || children}
    </EmptySpaceWrapper>
  )
}

export default EmptySpace
